import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'

import moment from 'moment-timezone'
import 'react-datepicker/dist/react-datepicker-cssmodules.css'
import 'react-datepicker/dist/react-datepicker.css'
import { Moment } from 'moment/moment'
import { IDateRange } from './interfaces'
import {
  setHours,
  setMinutes,
  setSeconds,
} from 'date-fns'

const TODAY: Moment = moment()

export const excludeTimes: Date[] = [
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 0),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 1),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 2),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 3),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 4),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 5),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 6),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 7),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 8),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 9),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 10),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 11),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 12),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 13),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 14),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 15),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 16),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 17),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 18),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 19),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 20),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 21),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 22),
  setHours(setMinutes(setSeconds(new Date(), 0), 30), 23)
]

const DateRangeComponent: React.FC<IDateRange> = ({ from,
                                                    to,
                                                    fromCallback,
                                                    toCallback,
                                                    minDate,
                                                    isClearable = false,
                                                    label,
                                                  }: IDateRange) => {
  const [fromDate, setFromDate] = useState<Date | null>(from)
  const [toDate, setToDate] = useState<Date | null>(to)

  useEffect(() => {
    const from = moment(fromDate)
    const to = moment(toDate)
    if (from.isSameOrAfter(to)) {
      setFromDate(to.subtract(1, 'days').toDate())
    }
  }, [toDate])

  useEffect(() => {
    fromCallback(fromDate)
  }, [fromDate])

  useEffect(() => {
    toCallback(toDate)
  }, [toDate])

  const handleFromRangeChange = (dates: [Date | null, Date | null]) => {
    if (dates) {
      const [start, end] = dates
      setFromDate(start)
      setToDate(end)
    } else {
      setFromDate(null)
    }
  }

  return (
    <div className="date-range-selector">
      <div className="col-md-12 main-content p-0">
        <div className="range">
          <div className="col-md-6 col-sm-12 section-header p-0">
            <div>{label || 'Range:'}</div>
          </div>
          <DatePicker
            wrapperClassName="w-100"
            selected={minDate ? (fromDate && fromDate > minDate ? fromDate : minDate) : fromDate}
            onChange={handleFromRangeChange}
            maxDate={TODAY.toDate()}
            minDate={minDate ?? undefined}
            dateFormat="dd/MM/yyyy"
            isClearable={isClearable}
            startDate={fromDate ?? undefined}
            endDate={toDate ?? undefined}
            selectsRange
            showIcon
            showMonthDropdown
            showYearDropdown
          />
        </div>
      </div>
    </div>
  )
}

export default DateRangeComponent
